<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >DealershipID</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.InternalDealerID.$error
                    }"
                    v-model="dealer.dealer_edit.InternalDealerID"
                    placeholder="Required"
                    type="text"
                    id="InternalDealerID"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.dealer.dealer_edit.InternalDealerID.$touch()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>

            <!-- <b-col md="3">
              <b-form-radio-group
                class="mr-3"
                id="Active"
                buttons
                button-variant="outline-primary"
                v-model="dealer.dealer_edit.Active"
                @change.native="addDirtyFieldRadio"
                name="Active"
              >
                <b-form-radio
                  class="mx-0 longStandardizedRadioWidth"
                  value="true"
                  >Active</b-form-radio
                >
                <b-form-radio
                  class="mx-0 longStandardizedRadioWidth"
                  value="false"
                  >Inactive</b-form-radio
                >
              </b-form-radio-group>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.Name.$error
                    }"
                    v-model="dealer.dealer_edit.Name"
                    placeholder="Required"
                    autocomplete="off"
                    type="text"
                    id="Name"
                    @input="$v.dealer.dealer_edit.Name.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Address</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.Address1.$error
                    }"
                    v-model="dealer.dealer_edit.Address1"
                    placeholder="Required"
                    type="text"
                    id="Address1"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.dealer.dealer_edit.Address1.$touch()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Building/Suite</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="dealer.dealer_edit.Address2"
                    type="text"
                    id="Address2"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >City</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.City.$error
                    }"
                    v-model="dealer.dealer_edit.City"
                    placeholder="Required"
                    type="text"
                    id="City"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.dealer.dealer_edit.City.$touch()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >State/Province</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.State.$error
                    }"
                    v-model="dealer.dealer_edit.State"
                    placeholder="Required"
                    type="text"
                    id="State"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.dealer.dealer_edit.State.$touch()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Postal Code</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.PostalCode.$error
                    }"
                    v-model="dealer.dealer_edit.PostalCode"
                    placeholder="Required"
                    type="text"
                    id="PostalCode"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="$v.dealer.dealer_edit.PostalCode.$touch()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Country</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="dealer.dealer_edit.Country"
                    type="text"
                    id="Country"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Phone (Main)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="dealer.dealer_edit.PhoneMain"
                    type="text"
                    id="PhoneMain"
                    v-mask="'(###) ###-####'"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Email (Main)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.EmailMain.$error
                    }"
                    v-model="dealer.dealer_edit.EmailMain"
                    type="email"
                    id="EmailMain"
                    autocomplete="off"
                    @input="$v.dealer.dealer_edit.EmailMain.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Phone (Service)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="dealer.dealer_edit.PhoneService"
                    type="text"
                    id="PhoneService"
                    v-mask="'(###) ###-####'"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Email (Service)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.EmailService.$error
                    }"
                    v-model="dealer.dealer_edit.EmailService"
                    type="email"
                    id="EmailService"
                    autocomplete="off"
                    @input="$v.dealer.dealer_edit.EmailService.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Phone (Sales)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="dealer.dealer_edit.PhoneSales"
                    type="text"
                    id="PhoneSales"
                    v-mask="'(###) ###-####'"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Email (Sales)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.EmailSales.$error
                    }"
                    v-model="dealer.dealer_edit.EmailSales"
                    type="email"
                    id="EmailSales"
                    autocomplete="off"
                    @input="$v.dealer.dealer_edit.EmailSales.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Phone (Accounting)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="dealer.dealer_edit.PhoneAccounting"
                    type="text"
                    id="PhoneAccounting"
                    v-mask="'(###) ###-####'"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Email (Accounting)</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred: $v.dealer.dealer_edit.EmailAccounting.$error
                    }"
                    v-model="dealer.dealer_edit.EmailAccounting"
                    type="email"
                    id="EmailAccounting"
                    autocomplete="off"
                    @input="$v.dealer.dealer_edit.EmailAccounting.$touch()"
                    v-on:change.native="addDirtyField"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <div class="form-group form-actions" style="float:left;">
                <b-button
                  v-if="dealer.dealer_edit.Active"
                  class="mr-2 mt-2"
                  style="color: white;"
                  size="md"
                  variant="primary"
                  @click="DashRouteTo('/dealers/edit/operations')"
                >
                  <span class="material-symbols-outlined">
                    overview
                  </span>

                  <span class="my_material-icon-label"
                    >Data Operations</span
                  ></b-button
                >
              </div>
              <div class="form-group form-actions" style="float:right;">
                <b-button
                  class="mr-2 mt-2"
                  size="md"
                  variant="outline-primary"
                  @click="back"
                >
                  <!-- <i class="fa fa-close"></i> -->
                  {{ CancelButtonVerbiage }}
                </b-button>
                <b-button
                  v-if="n_user.n_current_user.IsSU"
                  class="mr-0 mt-2"
                  size="md"
                  variant="primary"
                  type="submit"
                  :disabled="isClean"
                >
                  <i class="fa fa-save"></i>
                  Save
                </b-button>
              </div>

              <div class="form-group form-actions" style="float:right;">
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismissCountDown"
                  fade
                  variant="light"
                  :dismissed="(dismissCountdown = 0)"
                  @dismiss-count-down="countDownChanged"
                >
                  Your information has been saved
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismiss2CountDown"
                  fade
                  variant="danger"
                  :dismissed="(dismiss2Countdown = 0)"
                  @dismiss-count-down="countDown2Changed"
                >
                  Your information could not be saved. Check all fields
                  carefully.
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
                <b-alert
                  class="btn mr-4 mt-2"
                  :show="dismiss3CountDown"
                  fade
                  variant="danger"
                  :dismissed="(dismiss3Countdown = 0)"
                  @dismiss-count-down="countDown3Changed"
                >
                  Dealer already exists! Your information could not be saved.
                  <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
                </b-alert>
              </div>
            </b-col>
          </b-row>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EmployeeCard from "@/components/cards/EmployeeCard.vue";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import { CoolSelect } from "vue-cool-select";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
export default {
  name: "DealerProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },

    async save() {
      if (
        this.$store.state.dealer.dealers.find(
          dealer =>
            dealer.DealershipID !==
              this.$store.state.dealer.dealer_edit.DealershipID &&
            dealer.Name.toLowerCase() ===
              this.$store.state.dealer.dealer_edit.Name.toLowerCase() &&
            dealer.InternalDealerID.toLowerCase() ===
              this.$store.state.dealer.dealer_edit.InternalDealerID.toLowerCase()
        )
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      //double check the database
      // if (this.$store.state.dealer.dealer_edit.UserProfileID === -1) {
      //   var _existing_id = -1;

      //   await this.$store
      //     .dispatch(
      //       "dealer/doesDealerExist",
      //       this.$store.state.dealer.dealer_edit.Name
      //     )
      //     .then(response => {
      //       _existing_id = response.data["DoesDealerExistResult"];
      //     });

      //   if (_existing_id > -1) {
      //     this.dismiss3CountDown = this.dismiss3Secs;
      //     return;
      //   }
      // }

      this.$v.$touch();
      if (this.$v.$error) {
        console.log(this.$v.$error);
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.$store.state.saveOp.localUrl = "/Dealer/Save/";
        this.$store.state.saveOp.localVariableName = "_d";
        this.$store.state.saveOp.localVariableObject = this.$store.state.dealer.dealer_edit;
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "DealershipID";
        this.$store.state.saveOp.localReturnObject = "SaveDealerResult";

        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );

        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
      }
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.name
      );
      this.dirtyFields.push({
        FieldName: event.target.name,
        FieldValue: event.target.value
      });
      //console.log(this.$store.state.dealer.dealer_edit);
    },
    addDirtyFieldRadioWithCast: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.name
      );
      this.dirtyFields.push({
        FieldName: event.target.name,
        FieldValue: event.target.value
      });
      if (event.target.value == "true") {
        this.$store.state.dealer.dealer_edit.IsBoost = true;
      } else {
        this.$store.state.dealer.dealer_edit.IsBoost = false;
      }

      //console.log(this.$store.state.dealer.dealer_edit);
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    togglePassword: function() {
      const passwordField = document.querySelector("#Password");
      if (passwordField.getAttribute("type") === "password") {
        passwordField.setAttribute("type", "text");
      } else {
        passwordField.setAttribute("type", "password");
      }
    },
    DashRouteTo(_page) {
      this.save();
      this.$router.push(_page);
    }
  },
  computed: {
    ...mapState(["dealer", "n_user", "saveOp"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    },
    ShowServTemplates() {
      return !this.$store.state.dealer.dealer_edit.IsBoost;
    },
    CancelButtonVerbiage() {
      if (this.$store.state.n_user.n_current_user.IsSU) {
        return "Cancel";
      } else {
        return "Close";
      }
    }
  },
  components: {
    EmployeeCard,
    CoolSelect
  },
  validations: {
    dealer: {
      dealer_edit: {
        InternalDealerID: {
          required
        },
        Name: {
          required
        },
        Address1: {
          required
        },
        City: {
          required
        },
        State: {
          required
        },
        PostalCode: {
          required,
          minLength: minLength(5)
        },
        EmailMain: {
          email
        },
        EmailService: {
          email
        },
        EmailSales: {
          email
        },
        EmailAccounting: {
          email
        }
      }
    }
  },
  watch: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.testred {
  color: red;
  border-color: red;
}
</style>
